import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { key: 0 }

import { computed, onMounted, ref, VNode } from "vue";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";

import { InputVariant } from "@/types";

interface Props {
  label?: string;
  labelIcon?: string | object | (() => VNode) | null;
  variant?: InputVariant;
  modelValue?: string | number;
  testId?: string;
  disabled?: boolean;
  required?: boolean;
}
export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneNumberInput',
  props: {
    label: { default: "" },
    labelIcon: {},
    variant: { default: "primary" },
    modelValue: { default: "" },
    testId: { default: "phone-input" },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

;

const props = __props;

const emit = __emit;

const phone = computed({
  get: () => props.modelValue,
  set: (val: string | number) => emit("update:modelValue", val)
});
const variantClass = computed(() => props.variant ?? 'primary');
const backgroundStyle = computed(() => ({
  background:
    phone.value && ["primary", "admin"].includes(props.variant)
      ? "rgba(28, 86, 145, 0.05)"
      : "none",
}));

const telInputRef = ref<InstanceType<typeof VueTelInput> | null>(null);

onMounted(() => {
  // Wait for DOM to be ready and try to find the internal input element
  const input = telInputRef.value?.$el?.querySelector('input');
  if (input) {
    input.dataset.testid = props.testId;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['tel-input-wrapper w-100', variantClass.value])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "input-label d-flex align-items-center",
          for: __props.testId
        }, [
          _createTextVNode(_toDisplayString(__props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true),
          (__props.labelIcon)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.labelIcon), {
                key: 1,
                class: "ms-1"
              }))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_unref(VueTelInput), _mergeProps({
      ref_key: "telInputRef",
      ref: telInputRef,
      modelValue: phone.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phone).value = $event)),
      mode: "international",
      style: { ...backgroundStyle.value },
      disabled: __props.disabled,
      dropdownOptions: {
        showFlags: true,
        showDialCodeInList: true,
        width: '240px',
      },
      inputOptions: {
        id: __props.testId,
        placeholder: 'Enter phone number',
        maxlength: 17,
        styleClasses: 'vti-phone-input',
        showDialCode: true
      },
      defaultCountry: 234,
      validCharactersOnly: true
    }, _ctx.$attrs), null, 16, ["modelValue", "style", "disabled", "inputOptions"])
  ], 2))
}
}

})